import React, {useEffect} from "react";
import {
    Footer,
    List,
    ListItem,
    FooterLink
} from "@deere/ux.uxframe-react";

export default function AEFooter() {
    useEffect(() => {
        // Walkme
        if (window.location.hostname !== "localhost") {
            const walkme = document.createElement("script");

            walkme.type = "text/javascript";
            walkme.async = true;
            const s = document.getElementsByTagName("script")[0];

            s.parentNode.insertBefore(walkme, s);
            window._walkmeConfig = {
                smartLoad: true,
            };
            walkme.src = process.env.REACT_APP_WALKME_URL;
            walkme.async = true;
            document.body.appendChild(walkme);
        }
    }, []);
    return (
        <Footer>
            <List className="nav">
                <ListItem>
                    <FooterLink href="https://jdsn.deere.com">Home</FooterLink>
                </ListItem>
                <ListItem>
                    <FooterLink href="http://www.deere.com/suppliercode">
                        Supplier Code of Conduct
                    </FooterLink>
                </ListItem>
                <ListItem>
                    <FooterLink
                        href="https://www.deere.com/en/privacy-and-data/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Privacy & Data
                    </FooterLink>
                </ListItem>
                <ListItem>
                    <FooterLink
                        href="https://www.deere.com/en/privacy-and-data/terms/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Terms of Use
                    </FooterLink>
                </ListItem>
            </List>
        </Footer>
    );
}